// extracted by mini-css-extract-plugin
module.exports = {"root":"cf9e9e3e","img":"c271a80c"};